import NavigationHeaderWrapper from './NavigationHeader.Wrapper';

export default NavigationHeaderWrapper;
